import React from 'react';
import type { Table } from '../../types';
import { useI18n } from '../../i18n/I18nContext';

export interface TableDetailsFormProps {
  table: Table;
  defaultTableColor: string;
  readOnly?: boolean;
  nameInputRef: React.Ref<HTMLInputElement>;
  onNameChange: (value: string) => void;
  onPersonChange: (value: string) => void;
  onTableColorChange: (value: string) => void;
  onResetTableColor: () => void;
}

const TableDetailsForm: React.FC<TableDetailsFormProps> = ({
  table,
  defaultTableColor,
  readOnly = false,
  nameInputRef,
  onNameChange,
  onPersonChange,
  onTableColorChange,
  onResetTableColor,
}) => {
  const { t } = useI18n();
  return (
    <>
      <div className="name-row">
        <div className="name-field">
          <label>{t('table.name')}</label>
          <input ref={nameInputRef} type="text" value={table.name} disabled={readOnly} translate="no" onChange={e => onNameChange(e.target.value)} />
        </div>
        <div className="table-color-group">
          <label className="table-color-label">{t('table.tableColor')}</label>
          <div className="table-color-row compact">
            <input
              type="color"
              value={table.color || defaultTableColor}
              disabled={readOnly}
              onChange={e => onTableColorChange(e.target.value)}
              title={t('table.tableColor')}
            />
            <button type="button" className="secondary-button" onClick={onResetTableColor} disabled={readOnly}>
              {t('table.defaultColor')}
            </button>
          </div>
        </div>
      </div>
      <label>{t('table.person')}</label>
      <input type="text" value={table.person || ''} disabled={readOnly} translate="no" onChange={e => onPersonChange(e.target.value)} />
    </>
  );
};

export default TableDetailsForm;
